import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
  useMemo,
} from "react";
import { IUserData } from "../interfaces/auth";
import Cookies from "js-cookie";
import { COOKIE_AUTH_TOKEN } from "../constants/common";
import { UserServices } from "../services/user";

interface AuthContextType {
  user: IUserData | null;
  setUser: (user: IUserData | null) => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<IUserData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const token = Cookies.get(COOKIE_AUTH_TOKEN);
      if (token) {
        try {
          const res = (await UserServices.getMe()) as unknown as {
            success: boolean;
            data: IUserData;
          };
          if (res.success) {
            setUser(res.data);
          }
        } catch (err) {
          setUser(null);
        } finally {
          setLoading(false);
        }
      }
      setLoading(false);
    };
    fetchUser();
  }, []);

  const contextValue = useMemo(() => ({
  user,
  setUser,
  loading,
}), [user, setUser, loading]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
